import React, { useEffect, useState } from 'react'
import { useLocation, useHistory, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  useErrorService,
  surveyType,
  PrintableArea,
  buildGroupCombinedSummaryFileBase,
} from '@abroad/components'
import {
  WisdomAssessmentResult,
  ProsperityAssessmentResult,
  AwarenessAssessmentResult,
  useGroupName,
} from '../components'
import API from '../utils/API'

export const TeamSurveyResult = () => {
  const { state, search } = useLocation()
  const history = useHistory()
  const { teamId } = useParams()
  const Error = useErrorService()
  const [survey, setSurvey] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const groupNameFromHook = useGroupName(teamId)
  const query = new URLSearchParams(search)
  const querySurveyType = query.get('surveyType')
  const resolvedSurveyType =
    state?.surveyType || querySurveyType || surveyType.AWARENESS
  const teamName =
    state?.teamName || query.get('teamName') || groupNameFromHook || ''
  const pdfFileNameBase = buildGroupCombinedSummaryFileBase(
    teamName || 'Group',
    resolvedSurveyType,
  )

  useEffect(() => {
    if (!teamId) {
      history.replace('/admin/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId, history])

  useEffect(() => {
    const getCombinedResult = async () => {
      try {
        const { data } = await API.AdminAPI.teams.combinedResult(teamId)
        setSurvey(
          resolvedSurveyType === surveyType.WISDOM
            ? data?.wisdom
            : resolvedSurveyType === surveyType.PROSPERITY
            ? data?.prosperity
            : data?.awareness,
        )
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          //history.replace('/404')
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }
    if (teamId && resolvedSurveyType) {
      getCombinedResult()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId, resolvedSurveyType])

  const subtitleName = (teamName || 'Group').toUpperCase()

  return (
    <>
      <Helmet>
        <title>{`${teamName || 'Group'}'s Survey Result | Abroad`}</title>
        <meta
          name='title'
          content={`${teamName || 'Group'}'s Survey Result | Abroad`}></meta>
        <meta
          property='og:title'
          content={`${teamName || 'Group'}'s Survey Result | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`${teamName || 'Group'}'s Survey Result | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/admin/groups`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/groups`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/groups`}></meta>
      </Helmet>
      <main>
        {resolvedSurveyType === surveyType.WISDOM ? (
          <WisdomAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Group Wisdom Assessment'
            subHeaderText={`${subtitleName}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization and themselves during the specified time period.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : resolvedSurveyType === surveyType.PROSPERITY ? (
          <ProsperityAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Group True Prosperity Assessment'
            subHeaderText={`${subtitleName}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization and themselves during the specified time period.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : (
          <AwarenessAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Group Awareness Assessment'
            subHeaderText={`${subtitleName}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization and themselves during the specified time period.'
            pdfFileNameBase={pdfFileNameBase}
          />
        )}
      </main>
      <PrintableArea printSelector='main' />
    </>
  )
}
